import ValidationType from '../ValidationType';

class DoesNotContainValueCaseInsensitive extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const compareValue = validation.value || '';
    const currentValue = fieldResponse.currentValue || '';

    // Attempt to find the compare value within the current value (case-insensitive)
    const compareValueUpper = compareValue.toUpperCase();
    const currentValueUpper = currentValue.toUpperCase();
    if (currentValueUpper && currentValueUpper.includes(compareValueUpper)) {
      const error = this.createValidationError({
        fieldResponse,
        key: 'ERROR_DOES_NOT_CONTAIN_VALUE_CASE_INSENSITIVE',
        values: { value: compareValue },
        message: `Value should not contain '${compareValue}'`,
      });
      errors.push(error);
    }
    return errors;
  }
}

export default DoesNotContainValueCaseInsensitive;
